import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AddressLine, SEPARATOR} from '../../../../../../../../model/address-line';

@Component({
  selector: 'app-address-label',
  templateUrl: './address-label.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AddressLabelComponent implements OnInit {
  @Input() public addressLines: AddressLine[];
  @Output() addressLinesChange = new EventEmitter<AddressLine[]>();
  @Input() public legend: string;


  constructor() {
  }

  ngOnInit(): void {
  }
  public isValid(line: AddressLine): boolean {
    if (line.sDataLib === SEPARATOR) {
      return true;
    }
    return line.sDataLibValue !== '' && line.sDataLibValue !== line.sDataLib;

  }
}
